export default __webpack_public_path__ + "static/Денежный поток 303+404_0-3b7905e5a42eb40167e9639f0995886b.png";